/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Requireauth_Reviews_Description1Inputs */

const he_auth_requireauth_reviews_description1 = /** @type {(inputs: Auth_Requireauth_Reviews_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יש צורך בהתחברות כדי לפרסם ביקורות ולהעלות תמונות.`)
};

const en_auth_requireauth_reviews_description1 = /** @type {(inputs: Auth_Requireauth_Reviews_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You need an account to post reviews and upload media.`)
};

/**
* | output |
* | --- |
* | "You need an account to post reviews and upload media." |
*
* @param {Auth_Requireauth_Reviews_Description1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_requireauth_reviews_description1 = /** @type {((inputs?: Auth_Requireauth_Reviews_Description1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Requireauth_Reviews_Description1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_requireauth_reviews_description1(inputs)
	return en_auth_requireauth_reviews_description1(inputs)
});
export { auth_requireauth_reviews_description1 as "auth_requireAuth_reviews_description" }